import { Camera } from "../../core/Camera";
import { RenderContext3D } from "../../core/render/RenderContext3D";
export class WebXRCamera extends Camera {
    constructor() {
        super(...arguments);
        this.isWebXR = true;
    }
    get renderTarget() {
        return this._internalRenderTexture;
    }
    set renderTarget(value) {
        this._internalRenderTexture = value;
    }
    set clientWidth(value) {
        this._clientWidth = value;
    }
    set clientHeight(value) {
        this._clientHeight = value;
    }
    get clientWidth() {
        return this._clientWidth;
    }
    get clientHeight() {
        return this._clientHeight;
    }
    _restoreView(gl) {
        var viewport = this.viewport;
        var vpX, vpY;
        var vpW = viewport.width;
        var vpH = viewport.height;
        if (this._needInternalRenderTexture()) {
            vpX = 0;
            vpY = 0;
        }
        else {
            vpX = viewport.x;
            vpY = this._getCanvasHeight() - viewport.y - vpH;
        }
        gl.viewport(vpX, vpY, vpW, vpH);
    }
    render() {
        if (!this.activeInHierarchy)
            return;
        var viewport = this.viewport;
        var needInternalRT = true;
        var context = RenderContext3D._instance;
        var scene = context.scene = this._scene;
        context.pipelineMode = context.configPipeLineMode;
    }
    _renderMainPass(context, viewport, scene, shader, replacementTag, needInternalRT) {
    }
    _calculateProjectionMatrix() {
    }
    clear(gl) {
        gl.viewport(0, 0, this._clientWidth, this._clientHeight);
        gl.scissor(0, 0, this._clientWidth, this._clientHeight);
        gl.clearColor(this.clearColor.r, this.clearColor.g, this.clearColor.b, this.clearColor.a);
        gl.depthMask(true);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    }
    destroy() {
        super.destroy(true);
    }
}
